import API_BASE from './apiBase';
import { authHeaders } from './authService';

// Re-reads a container after a fullness correction. Accepts the container
// object (or a bare id); the legacy version passed the object straight into
// the URL and always 404'd.
export const updatePercentage = async (container) => {
  const id = typeof container === 'string' ? container : container?.containerId;
  if (!id) throw new Error('container id is required');
  const response = await fetch(`${API_BASE}/containers/${encodeURIComponent(id)}`, { headers: await authHeaders() });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const result = await response.json();
  return result.data;
};
